import {gql} from "@apollo/client";

export const getCountriesQuery = gql`
    query GetCountriesQuery {
        allCountries {
            id
            name
        }
    }
`;
